import { defineMessage } from "react-intl";
import type { FigureMetadata } from "../components/figure";

export const metadata: FigureMetadata = {
  id: "GPE",
  title: defineMessage({
    id: "fig.finance.aid.GPE.title",
    defaultMessage: ``,
  }),
  caption: defineMessage({
    id: "fig.finance.aid.GPE.caption",
    defaultMessage: ``,
  }),
  source: defineMessage({
    id: "fig.finance.aid.GPE.source",
    defaultMessage: ``,
  }),
};
